module.exports = __webpack_public_path__ + "static/media/whatsapp-purple-icon.60a4d592.svg";